import React from 'react';
import PropTypes from 'prop-types';

import { TextButton } from '@zillow/constellation';

import './style.scss';

const propTypes = {
    onClick: PropTypes.func,
};

const defaultProps = {
    onClick: () => { },
};

const BillingViewAll = ({ onClick }) => (
    <div className="Billing-view-all">
        <TextButton onClick={onClick}>
            View All
        </TextButton>
    </div>
);

BillingViewAll.propTypes = propTypes;
BillingViewAll.defaultProps = defaultProps;
export default BillingViewAll;
